import React, { useEffect } from 'react';

import {
  DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS,
} from 'common/dataTableConstants';

import {
  JOB_STATUS_CREATED,
  JOB_STATUS_COMPLETED,
  JOB_STATUS_CANCELLED,
  JOB_ORDER_STATUS_FAILED,
  JOB_ORDER_STATUS_COMPLETED,
} from 'common/jobConstants';

import {
  actionDataTableLoadItems,
} from 'client/helpers/dataTables';

import useBranch from 'client/hooks/useBranch';
import JobOrderActions from 'client/actions/JobOrder';

import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrSunSetupDriverOrderPage from 'client/components/SrSunSetupDriverOrder/SrSunSetupDriverOrderPage';

function getDataTableSettingsFromProps({
  driverId,
  orderId,
}) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS,
    rootViewId: DATA_TABLE_SOURCE_SUNSETUP_DRIVER_ORDERS,
    initialViewSettings: {
      filter: {
        'jobOrders.id': orderId,
        'jobOrders.driverId': driverId,
      },
      sort: {
        'jobOrders.createdDate': 'desc',
      },
    },
    count: 1,
    itemsPropName:'jobOrders',
  };

  return dataTableSettings;
}

const SrSunSetupDriverOrder = ({
  driverId,
  orderId,
  history,
}) => {
  const {
    dispatch,
  } = useBranch({});

  let _reloadItems;

  useEffect(() => {
    const interval = global.setInterval(() => {
      if (_reloadItems) {
        _reloadItems({
          count: 1,
          filter: {
            'jobOrders.id': orderId,
            'jobOrders.driverId': driverId,
          },
        });
      }
    }, 2000);
    return () => {
      global.clearInterval(interval);
    };
  });

  return (
    <SrDataTableConnected
      {...getDataTableSettingsFromProps({ driverId, orderId })}
    >
      {({ jobOrders, dataTableApiState, onInfiniteScrollWrapperRef, reloadItems }) => {
        const jobOrder = jobOrders[0];
        _reloadItems = reloadItems;

        const onCompleteOrder = () => {
          const jobsIncompleted = jobOrder.jobs.filter((job) => job.status === JOB_STATUS_CREATED);

          if (jobsIncompleted.length) {
            return global.alert('Mark jobs as completed or incompleted');
          }

          dispatch(JobOrderActions.updateStatus, {
            jobOrderId: jobOrder.id,
            status: jobOrder.jobs
              .filter(({ status }) => status !== JOB_STATUS_CANCELLED)
              .every((job) => job.status === JOB_STATUS_COMPLETED)
              ? JOB_ORDER_STATUS_COMPLETED
              : JOB_ORDER_STATUS_FAILED,
          }).then(() => {
            const dataTableSettings = getDataTableSettingsFromProps({ driverId, orderId });

            dispatch(actionDataTableLoadItems, {
              ...dataTableSettings,
              ...dataTableSettings.initialViewSettings,
            });

            history.push(`/sunsetup/drivers/${driverId}/orders`);
          });
        };

        return (
          <>
            <div ref={onInfiniteScrollWrapperRef}>
              {jobOrder && (
                <SrSunSetupDriverOrderPage
                  jobOrder={jobOrder}
                  onComplete={onCompleteOrder}
                />
              )}
              {dataTableApiState.inProgress && (
                <SrFlex justify='center'>
                  <div className='loading-gif' />
                </SrFlex>
              )}
            </div>
          </>
        );
      }}
    </SrDataTableConnected>
  );
};

SrSunSetupDriverOrder.displayName = 'SrSunSetupDriverOrder';

export default SrSunSetupDriverOrder;
